interface ScrollToBottomButtonProps {
  visible: boolean;
  onClick: () => void;
}

export const ScrollToBottomButton = ({ visible, onClick }: ScrollToBottomButtonProps) => {
  return (
    <button
      className="text flex-row-center px-5 p-3 rounded-full bg-white/90 border border-gray-200 shadow-md cursor-pointer active:opacity-70 transition-all duration-200 z-10 text-font-size-body2 text-textcolor-black/70 font-bold"
      style={{
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
      }}
      onClick={onClick}
    >
      ↓ つづきをよむ
    </button>
  );
};
